import React from "react";
import { useTheme } from "../../contexts/ThemeContext";

const TONES = {
  active: { bg: "rgba(74,222,128,0.15)", fg: "#4ade80" },
  pending: { bg: "rgba(236,178,54,0.15)", fg: "#ECB236" },
  danger: { bg: "rgba(225,29,72,0.15)", fg: "#e11d48" },
};

/**
 * Badge tipo marketplace ("Activo", "Predeterminado") en vez de texto plano.
 */
export const Pill = ({ children, tone = "neutral" }) => {
  const { mode } = useTheme() || { mode: "light" };
  const isDark = mode === "dark";
  const neutral = { bg: isDark ? "rgba(255,255,255,0.08)" : "#f1f5f9", fg: isDark ? "#c7c6d4" : "#64748b" };
  const { bg, fg } = TONES[tone] || neutral;

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: "4px 12px",
        borderRadius: 999,
        fontSize: 11,
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.04em",
        backgroundColor: bg,
        color: fg,
        whiteSpace: "nowrap",
      }}
    >
      {children}
    </span>
  );
};

export default Pill;
